import { createSetting, useDialog } from '@shopex/finder'

export const tableSetting = (vm) => createSetting({
  columns: [
    {
      name: '国补订单号',
      key: 'order_id',
      minWidth: 200
    },
    {
      name: '国补支付单号',
      key: 'subsidy_payment_no',
      minWidth: 150
    },
    {
      name: '国补商品',
      key: '',
      minWidth: 150,
      render: (h, { row }) => {
        return <span>{row.item_info.item_name}</span>
      }
    },
    {
      name: '商品类型',
      key: 'subsidy_goods_type',
      minWidth: 80,
    },
    {
      name: '商品实付金额',
      key: 'goods_payment_amount',
      minWidth: 130,
      render: (h, { row }) => {
        return <span>¥ {row.goods_payment_amount / 100}</span>
      }
    },
    {
      name: 'Apple ID',
      key: 'subsidy_goods_type',
      minWidth: 100,
      render: (h, { row }) => {
        return <span>{row.distributor_info.shop_code}</span>
      }
    },
    {
      name: 'imei',
      key: 'imei_code',
      minWidth: 100
    },
    {
      name: '顺丰单号',
      key: 'delivery_code',
      minWidth: 100,
    },
    {
      name: '经销商名称',
      key: 'dealer_info_name',
      minWidth: 100,
      render: (h, { row }) => {
        return <span>{row.dealer_info.name}</span>
      }
    },
    {
      name: '经销商HQID',
      key: 'dealer_hqid',
      minWidth: 100,
      render: (h, { row }) => {
        return <span>{row.dealer_info.dealer_hqid}</span>
      }
    },
    {
      name: '分销商HQID',
      key: 'distributor_hqid',
      minWidth: 100,
      render: (h, { row }) => {
        return <span>{row.dealer_info.distributor_hqid}</span>
      }
    },
    {
      name: '分销商VAD',
      key: 'distributor_vad',
      minWidth: 100,
      render: (h, { row }) => {
        return <span>{row.dealer_info.distributor_vad}</span>
      }
    },
    {
      name: '渠道RTM',
      key: 'channel_rtm',
      minWidth: 100,
      render: (h, { row }) => {
        return <span>{row.dealer_info.channel_rtm}</span>
      }
    },
    {
      name: '补贴金额',
      key: 'subsidy_amount',
      minWidth: 100,
      render: (h, { row }) => {
        return <span>¥ {row.subsidy_amount / 100}</span>
      }
    },
    {
      name: '国补门店',
      key: 'distributor_info.name',
      minWidth: 180,
      render: (h, { row }) => {
        return <span>{row.distributor_info.name}</span>
      }
    },
    {
      name: '核验照片',
      key: '',
      minWidth: 300,
      render: (h, { row }) => {
        if (!row.upload_photo) return null
        const imdList = row.upload_photo.map(item => item.photoUrl) || []
        return imdList.map((imd) => {
          return (
            <el-image
              style="width: 45px; height: 45px;margin-right: 5px;border-radius: 5px;"
              src={imd}
              fit="fit"
              preview-src-list={imdList}
            />
          )
        })
      }
    },
    {
      name: '商品SN',
      key: 'goods_sn',
      minWidth: 150,
    },
  ],
})
